import React, { useState, useEffect } from 'react'
import CoBorrowerGuarantardetailingPagecomponent from '../../../presentationals/Admin/CustomerPages/CoBorrowerGuarantardetailingPage.component';
import Loader from '../../../presentationals/Loader/Loader.component'
import KarzaPOPUPUI from '../../../presentationals/Popup/KarzaPopup.component'
import AAdharPopup from '../../../presentationals/Popup/KarzaAddharPopup.component'
import Popup from '../../../presentationals/Popup/Popup.component'
import { getAllUserDetailsIncompleteByUserId, panProfileDetails, aadharXmlData, aadharXmlDetails, getDocumentByUserId, getUserDealerAgentInfoById } from '../AdminActionCreator.component';

const customStylePopup = {
    zIndex: '9'
}

const currenPage = 1;
const totalItems = 20;

export default function CoBorrowerGuarantardetailingPageContainer({ userDetails, viewType, admin ,PayloadBorrowerId}) {
    const [loader, setLoader] = useState(false)
    const [popups, setpopups] = useState({ show: false, popupStatus: '' })
    const [allData, setAllData] = useState({})
    const [panPopup, setPanPopup] = useState(false)
    const [panData, setpanData] = useState({})
    const [aadhaarPopup, setAadhaarPopup] = useState(false)
    const [aadhaarData, setaadhaarData] = useState({})
    const [aadhaarAddressData, setaadhaarAddressData] = useState("")
    const [aadhaarAddressPopupData, setaadhaarAddressPopupData] = useState("")
    const [verificationType, setverificationType] = useState("")
    const [documentData, setDocumentData] = useState([])
    const [selectedDocument, setSelectedDocument] = useState({})
    const [allDocuments, setallDocuments] = useState([])
    const [agentDealerData,setagentDealerData] =useState({})
    const [editdata, setEditData] = useState({ show: false, type: "", data: {} })

    useEffect(() => {
        ApicallFn()
    }, [])

    const ApicallFn = () => {
        getAllUserDetailsIncompleteByUserIdFn(PayloadBorrowerId)
        panProfileDetailsFn(PayloadBorrowerId)
        aadharXmlDataFn(PayloadBorrowerId)
        getDocumentByUserIdFn(PayloadBorrowerId)
        getUserDealerAgentInfoByIdFn(PayloadBorrowerId)
    }

    const getUserDealerAgentInfoByIdFn = (id)=>{
        getUserDealerAgentInfoById(id,callback=>{
 if (callback?.status == 200 && callback?.message == "success") {
                setagentDealerData(callback?.data)
            } else {
               setagentDealerData({})
            }
        })
    }

    const handleLoader = (value) => {
        setLoader(value)
    }

    const getAllUserDetailsIncompleteByUserIdFn = (data) => {
        handleLoader(true)
        getAllUserDetailsIncompleteByUserId(data, callback => {
            handleLoader(false)
            setAllData(callback)
        })
    }

    const panProfileDetailsFn = (data) => {
        handleLoader(true)
        panProfileDetails(data, callback => {
            handleLoader(false)
            setpanData(callback)
        })
    }

    const getDocumentByUserIdFn = (data) => {
        handleLoader(true)
        getDocumentByUserId(currenPage, totalItems, data, callback => {
            handleLoader(false)
            setDocumentData(callback?.data)
            setallDocuments(callback?.data)
        })
    }

    const aadharXmlDetailsFn = (data, value) => {
        handleLoader(true)
        aadharXmlDetails(data, callback => {
            handleLoader(false)
            setaadhaarAddressPopupData(callback)
            const parsedAddress = JSON.parse(callback?.address)
            setaadhaarAddressData(parsedAddress)
            setAadhaarPopup(value)
        })
    }
    const aadharXmlDataFn = (data) => {
        handleLoader(true)
        aadharXmlData(data, callback => {
            handleLoader(false)
            setaadhaarData(callback)
            if (callback?.type == "aadhaar") {
                setverificationType("XML")
            } else if (callback?.type == "digiLocker") {
                setverificationType("Digilocker")
            }
        })
    }

    const closePopup = () => {
        setPanPopup(false)
        setAadhaarPopup(false)
        ApicallFn()
    }

    const handleAadhaarPanPopup = (value, type) => {
        if (type == "pan") {
            setPanPopup(value)
        }
        else if (type == "aadhaar") {
            aadharXmlDetailsFn(PayloadBorrowerId, value)
        }
    }

    const handleDocumentSelected = (e) => {
        const value = e.target.value;
        const ar = allDocuments?.documents?.filter((el) => el?.documentUrl === value)
        setSelectedDocument(ar[0])
    }

  

    const handleTextPopup = (type = false, text = "") => {
        setpopups({ show: type, popupStatus: text })
    }

   

    return (
        <>

            {
                loader ? <Loader /> : ''
            }
            {
                popups?.show ? <Popup popupStatus={popups?.popupStatus} closePopup={handleTextPopup} /> : ''
            }

            {
                panPopup ?
                    <KarzaPOPUPUI userDetail={userDetails} karzaData={panData} closePopup={closePopup} customStyle={customStylePopup} />
                    : ''}
            {
                aadhaarPopup ?
                    <AAdharPopup addressData={aadhaarAddressData} karzaData={aadhaarAddressPopupData} closePopup={closePopup} verificationType={verificationType} customStyle={customStylePopup} />
                    : ''}

            

            <CoBorrowerGuarantardetailingPagecomponent

                allData={allData}
                handleAadhaarPanPopup={handleAadhaarPanPopup}
                panData={panData}
                aadhaarData={aadhaarData}
                documentData={documentData}
                selectedDocument={selectedDocument}
                handleDocumentSelected={handleDocumentSelected}
                allDocuments={allDocuments}
                viewType={viewType}
            />
        </>
    )
}
